import { Card, CardContent } from "@/components/ui/card";
import { Calendar, CreditCard, Music, Shield } from "lucide-react";

export const EcosystemFeatures = () => {
  const features = [
    {
      icon: <Calendar className="h-8 w-8 text-primary" />,
      title: "Discover & Plan",
      description: "AI concierge finds your perfect night, group planning for celebrations, personalized event recommendations"
    },
    {
      icon: <CreditCard className="h-8 w-8 text-primary" />,
      title: "Pay & Earn",
      description: "Cashless wallet for seamless payments, loyalty rewards and VIP access, split bills with friends effortlessly"
    },
    {
      icon: <Music className="h-8 w-8 text-primary" />,
      title: "Create & Perform",
      description: "DJ and performer booking platform, promoter tools with smart analytics, venue management dashboard"
    },
    {
      icon: <Shield className="h-8 w-8 text-primary" />,
      title: "Secure & Verified",
      description: "Government-linked ID verification, real-time security monitoring, privacy-first facial recognition"
    }
  ];

  return (
    <section className="py-16 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Your Complete Nightlife Ecosystem
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Built for Australia's nightlife community - from patrons to performers, promoters to venues
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card key={index} className="bg-black/40 border-gray-800 backdrop-blur-sm">
              <CardContent className="p-6 text-center">
                <div className="flex justify-center mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-300 text-sm">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};